import eleIcon from "./showMoudle/eleIcon";
import eleStep from "./showMoudle/eleStep";
import eleMenu from "./showMoudle/eleMenu";
import eleImages from "./showMoudle/eleImages";
import eleVideos from "./showMoudle/eleVideos";
import eleSingleVideo from "./showMoudle/eleSingleVideo";
import eleSingleImage from "./showMoudle/eleSingleImage";

import eleMenuSimple from "./editMoudle/eleMenuSimple";
import eleStepSimple from "./editMoudle/eleStepSimple";
import eleIconSimple from "./editMoudle/eleIconSimple";
import eleVideosSimple from "./editMoudle/eleVideosSimple";
import eleImagesSimple from "./editMoudle/eleImagesSimple";
import eleSingleVideoSimple from "./editMoudle/eleSingleVideoSimple";
import eleSingleImageSimple from "./editMoudle/eleSingleImageSimple";

let elementComponets = {};
elementComponets.install = function (Vue, options) {
  Vue.component(eleStepSimple.name, eleStepSimple);
  Vue.component(eleMenuSimple.name, eleMenuSimple);
  Vue.component(eleIconSimple.name, eleIconSimple);
  Vue.component(eleImagesSimple.name, eleImagesSimple);
  Vue.component(eleVideosSimple.name, eleVideosSimple);
  Vue.component(eleSingleVideoSimple.name, eleSingleVideoSimple);
  Vue.component(eleSingleImageSimple.name, eleSingleImageSimple);

  Vue.component(eleIcon.name, eleIcon);
  Vue.component(eleStep.name, eleStep);
  Vue.component(eleMenu.name, eleMenu);
  Vue.component(eleVideos.name, eleVideos);
  Vue.component(eleImages.name, eleImages);
  Vue.component(eleSingleVideo.name, eleSingleVideo);
  Vue.component(eleSingleImage.name, eleSingleImage);
};
export default elementComponets



// WEBPACK FOOTER //
// ./src/lib/index.js